import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/app/StatusBadge";
import { api, formatApiError } from "@/lib/api";

const FILTERS = [["", "Semua"], ["new", "Baharu"], ["resolved", "Selesai"]];

export const ContactMessages = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("new");
  const load = () => api.get("/admin/contact-messages", { params: { status: filter } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = async (m) => {
    try { await api.patch(`/admin/contact-messages/${m.id}`, { status: m.status === "resolved" ? "new" : "resolved" }); toast.success("Status dikemas kini"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="space-y-3" data-testid="admin-contact">
      <div className="flex gap-2">{FILTERS.map(([k, l]) => <Button key={k || "all"} size="sm" variant={filter === k ? "default" : "outline"} className="rounded-xl" onClick={() => setFilter(k)} data-testid={`contact-filter-${k || "all"}`}>{l}</Button>)}</div>
      <Card className="max-h-[640px] divide-y divide-slate-100 overflow-y-auto">
        {!items.length && <p className="p-6 text-sm text-slate-500" data-testid="contact-empty">Tiada mesej.</p>}
        {items.map((m) => (
          <div key={m.id} className="space-y-2 p-4 text-sm" data-testid={`contact-msg-${m.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="flex flex-wrap items-center gap-2"><span className="rounded-full bg-violet-100 px-2 py-0.5 text-xs font-semibold text-violet-800">{m.category_label}</span><strong>{m.subject}</strong><span className="font-mono text-xs text-slate-400">#{m.id.slice(0, 8).toUpperCase()}</span></span>
              <Button size="sm" variant="outline" className={m.status === "resolved" ? "rounded-xl" : "rounded-xl text-emerald-700"} onClick={() => toggle(m)} data-testid={`contact-toggle-${m.id}`}>{m.status === "resolved" ? "Buka semula" : "Tanda selesai"}</Button>
            </div>
            <p className="text-xs text-slate-500">{m.name} · <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`} className="text-violet-700">{m.email}</a>{m.phone && ` · ${m.phone}`} · {new Date(m.created_at).toLocaleString("ms-MY")}{m.status === "resolved" && <span className="ml-1 font-semibold text-emerald-700">· Selesai</span>}</p>
            <p className="whitespace-pre-wrap text-slate-700">{m.message}</p>
          </div>
        ))}
      </Card>
    </div>
  );
};
